import { useParams } from "react-router-dom";
import Button from "../../../../shared/components/ui/Button";
import useCreatePayStudentProgramFromStudentView from "../../hooks/usePayStudentProgramFromStudentView";
import PayStudentProgramFromStudentViewForm from "./AssignedPayementToStudentForm";
import useProgramStudent from "../../../academyProgramDetail/hooks/students/useProgramStudent";
import React from "react";

export interface PayStudentProgramFromStudentViewProps {
  setOpenModal: (val: boolean) => void;
  onSuccess?: () => void;
}

export default function PayStudentProgramFromStudentView({
  setOpenModal,
  onSuccess,
}: PayStudentProgramFromStudentViewProps) {
  const { user_id } = useParams();
  const { control, loading, handleSubmit, watch, setValue } =
    useCreatePayStudentProgramFromStudentView({
      userId: +user_id!,
      setOpenModal,
      onSuccess,
    });

  const { programStudentByUserIdData, getProgramStudentsByUserId } =
    useProgramStudent({});

  React.useEffect(() => {
    getProgramStudentsByUserId(+user_id!);
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <PayStudentProgramFromStudentViewForm
        control={control}
        programStudentByUserIdData={programStudentByUserIdData}
        userId={+user_id!}
        watch={watch}
        setValue={setValue}
      />
      <div className="mt-2 flex items-center justify-end">
        <Button
          primary
          className="bg-[#072082]"
          loading={loading}
          type="submit"
          variant="filled"
        >
          <i className="fa-solid fa-save" /> Crear
        </Button>
      </div>
    </form>
  );
}
